import { memo, useEffect, useRef, useState } from 'react'
import * as Styled from './styled'
import { IImageStyle } from '../../types'

interface IProps {
  item: IImageStyle
  isSelected: boolean
  onStyleClick: (id: string | number) => void
}

const ImageStyleItem: React.FC<IProps> = ({
  item,
  isSelected,
  onStyleClick
}) => {
  const { id, name, thumbnailUrl } = item
  const [isLoading, setIsLoading] = useState(true)
  const styleItemRef = useRef<HTMLDivElement>(null)

  const handleImageLoad = () => {
    setIsLoading(false)
  }

  const handleClick = () => {
    if (isSelected) {
      return
    }
    onStyleClick(id)
  }

  useEffect(() => {
    if (isSelected) {
      styleItemRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      })
    }
  }, [isSelected])

  return (
    <Styled.StyleItem
      $isSelected={isSelected}
      onClick={handleClick}
      ref={styleItemRef}
    >
      {isLoading && <Styled.AISkeletonItemContainer />}
      <Styled.StyleImage
        src={thumbnailUrl}
        onLoad={handleImageLoad}
        $isLoading={isLoading}
      />
      <Styled.StyleName type="h4" color="white">
        {name}
      </Styled.StyleName>
    </Styled.StyleItem>
  )
}

export default memo(ImageStyleItem)
